<template>
  <footer class="relative  bg-gray-50">
    <div class="h-[3px] bg-gray-200"></div>

    <div  class="max-w-7xl mx-auto">
     <!-- Top Border -->

    <!-- Dekoratif Arka Plan -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden">
      <!-- Sol Üst Büyük Şekil -->
      <div
        class="absolute -left-64 -top-32 w-[800px] h-[600px] -rotate-[15deg] bg-gray-100/50"
      ></div>

      <!-- Sağ Alt Büyük Şekil -->
      <div
        class="absolute -right-96 bottom-0 w-[1000px] h-[600px] -rotate-[30deg] bg-gray-100/50"
      ></div>

      <!-- Orta Üst Şekil -->
      <div
        class="absolute right-1/4 -top-32 w-[400px] h-[400px] rotate-[30deg] bg-gray-100/40"
      ></div>

      <!-- Sol Alt Şekil -->
      <div
        class="absolute left-1/4 bottom-0 w-[300px] h-[300px] -rotate-[15deg] bg-gray-100/40"
      ></div>

      <!-- Orta Katman Şekil -->
      <div
        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rotate-[15deg] bg-gray-100/30"
      ></div>
    </div>

    <div class="container mx-auto relative">
      <!-- Ana İçerik -->
      <div class="py-16 lg:py-20">
        <div
          class="px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16"
        >
          <!-- Marka Bölümü -->
          <div class="space-y-8">
            <div class="space-y-6">
              <NuxtLink href="/" class="block">
                <img
                  :src="logoSrc"
                  :alt="`${siteTitle} Logo`"
                  class="h-12 mx-auto md:mx-0 hover:opacity-90 transition-all duration-300 hover:scale-105"
                />
              </NuxtLink>
              <p class="text-gray-700 text-sm leading-relaxed text-center md:text-left">
                {{ siteDescription }}
              </p>
            </div>

            <!-- Sosyal Medya -->
            <div
              class="flex items-center justify-center md:justify-start gap-4"
            >
              <a
                :href="socials.instagram"
                target="_blank"
                class="group"
                aria-label="Instagram"
              >
                <div
                  class="w-10 h-10 rounded-2xl bg-white shadow-sm group-hover:shadow-lg group-hover:-translate-y-1 flex items-center justify-center transition-all duration-300"
                >
                  <Icon
                    name="i-mdi:instagram"
                    class="w-5 h-5 text-orange-500 group-hover:text-orange-600 transition-colors duration-300"
                  />
                </div>
              </a>
              <a
                :href="socials.facebook"
                target="_blank"
                class="group"
                aria-label="Facebook"
              >
                <div
                  class="w-10 h-10 rounded-2xl bg-white shadow-sm group-hover:shadow-lg group-hover:-translate-y-1 flex items-center justify-center transition-all duration-300"
                >
                  <Icon
                    name="i-mdi:facebook"
                    class="w-5 h-5 text-orange-500 group-hover:text-orange-600 transition-colors duration-300"
                  />
                </div>
              </a>
              <a
                :href="socials.whatsapp"
                target="_blank"
                class="group"
                aria-label="WhatsApp"
              >
                <div
                  class="w-10 h-10 rounded-2xl bg-white shadow-sm group-hover:shadow-lg group-hover:-translate-y-1 flex items-center justify-center transition-all duration-300"
                >
                  <Icon
                    name="i-mdi:whatsapp"
                    class="w-5 h-5 text-orange-500 group-hover:text-orange-600 transition-colors duration-300"
                  />
                </div>
              </a>
            </div>
          </div>

          <!-- Kişisel -->
          <div class="space-y-6">
            <h3
              class="text-sm font-semibold text-gray-800 uppercase tracking-wider relative inline-block text-center md:text-left w-full group"
            >
              Kişisel
              <span
                class="absolute -bottom-2 left-1/2 md:left-0 w-12 h-[2px] bg-orange-500 transform -translate-x-1/2 md:translate-x-0 transition-all duration-300 group-hover:w-16"
              ></span>
            </h3>
            <ul class="space-y-3">
              <li v-for="(link, index) in personalLinks" :key="index">
                <NuxtLink
                  v-if="link.active"
                  :to="link.to"
                  class="text-gray-700 hover:text-orange-500 text-sm block py-1.5 text-center md:text-left transition-all duration-300 hover:translate-x-0.5 md:hover:translate-x-1.5 hover:font-medium"
                >
                  {{ link.text }}
                </NuxtLink>
                <span
                  v-else
                  class="text-gray-400 cursor-not-allowed text-sm block py-1.5 text-center md:text-left"
                >
                  {{ link.text }}
                  <span class="text-xs ml-1"></span>
                </span>
              </li>
            </ul>
          </div>

          <!-- Kurumsal -->
          <div class="space-y-6">
            <h3
              class="text-sm font-semibold text-gray-800 uppercase tracking-wider relative inline-block text-center md:text-left w-full group"
            >
              Kurumsal
              <span
                class="absolute -bottom-2 left-1/2 md:left-0 w-12 h-[2px] bg-orange-500 transform -translate-x-1/2 md:translate-x-0 transition-all duration-300 group-hover:w-16"
              ></span>
            </h3>
            <ul class="space-y-3">
              <li v-for="(link, index) in corporateLinks" :key="index">
                <NuxtLink
                  v-if="link.active"
                  :to="link.to"
                  class="text-gray-700 hover:text-orange-500 text-sm block py-1.5 text-center md:text-left transition-all duration-300 hover:translate-x-0.5 md:hover:translate-x-1.5 hover:font-medium"
                >
                  {{ link.text }}
                </NuxtLink>
                <span
                  v-else
                  class="text-gray-400 cursor-not-allowed text-sm block py-1.5 text-center md:text-left"
                >
                  {{ link.text }}
                  <span class="text-xs ml-1"></span>
                </span>
              </li>
            </ul>
          </div>

          <!-- İletişim -->
          <div class="space-y-6">
            <h3
              class="text-sm font-semibold text-gray-800 uppercase tracking-wider relative inline-block text-center md:text-left w-full group"
            >
              İletişim
              <span
                class="absolute -bottom-2 left-1/2 md:left-0 w-12 h-[2px] bg-orange-500 transform -translate-x-1/2 md:translate-x-0 transition-all duration-300 group-hover:w-16"
              ></span>
            </h3>
            <ul class="space-y-3">
              <li class="flex justify-center md:justify-start">
                <a
                  :href="socials.whatsapp"
                  target="_blank"
                  class="group inline-flex items-center gap-3 text-gray-700 hover:text-orange-500 text-sm py-1.5 transition-all duration-300 hover:translate-x-0.5 md:hover:translate-x-1.5 hover:font-medium"
                >
                  <div
                    class="w-8 h-8 rounded-2xl bg-white shadow-sm group-hover:shadow-lg group-hover:-translate-y-1 flex items-center justify-center transition-all duration-300"
                  >
                    <Icon
                      name="i-mdi:whatsapp"
                      class="w-4 h-4 text-orange-500 group-hover:text-orange-600 transition-colors duration-300"
                    />
                  </div>
                  <span>WhatsApp Destek</span>
                </a>
              </li>
              <li class="flex justify-center md:justify-start">
                <a
                  :href="`mailto:${supportEmail}`"
                  class="group inline-flex items-center gap-3 text-gray-700 hover:text-orange-500 text-sm py-1.5 transition-all duration-300 hover:translate-x-0.5 md:hover:translate-x-1.5 hover:font-medium"
                >
                  <div
                    class="w-8 h-8 rounded-2xl bg-white shadow-sm group-hover:shadow-lg group-hover:-translate-y-1 flex items-center justify-center transition-all duration-300"
                  >
                    <UIcon
                      name="i-heroicons-envelope"
                      class="w-4 h-4 text-orange-500 group-hover:text-orange-600 transition-colors duration-300"
                    />
                  </div>
                  <span>{{ supportEmail }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Alt Bilgi -->
      <div class="py-6 border-t border-gray-200">
        <div class="text-center px-6">
          <p class="text-sm text-gray-600">
            © {{ new Date().getFullYear() }} - MMS YAZILIM TEKNOLOJİ LİMİTED ŞİRKETİ	
          </p>
        </div>
      </div>
    </div>
   </div>
  </footer>
</template>

<script setup>
const siteSettings = useSiteSettingsStore()
const { title: siteTitle, description: siteDescription, supportEmail, socials, logoUrl: logoSrc } = storeToRefs(siteSettings)
const personalLinks = [
  { to: '/hesap/siparislerim', text: 'Siparişlerim', active: true },
  { to: '#', text: 'Favorilerim', active: false },
  { to: '/hesap/adreslerim', text: 'Adreslerim', active: true },
  { to: '#', text: 'Kuponlarım', active: false },
  { to: '/sepet', text: 'Sepetim', active: true }
]

const corporateLinks = [
  { to: '/menu/hakkimizda', text: 'Hakkımızda', active: false },
  { to: '#', text: 'Nasıl Satarım?', active: false },
  { to: '#', text: 'Nasıl Alırım?', active: false },
  { to: '#', text: 'Gizlilik Politikası', active: false },
  { to: '#', text: 'Kullanım Koşulları', active: false },
  { to: '#', text: 'Mesafeli Satış Sözleşmesi', active: false }
]
</script>
